import React from "react";
import RecentArea from "components/ui/common/recent/RecentArea";

class RecentChatsMode extends React.Component {

	render() {
		return <RecentArea />
	}
}

export default RecentChatsMode;